// removed by extract-text-webpack-plugin
module.exports = {"root":"_3-qgeZ7","content":"_2JCntfp","count":"_2XFDIKN","text":"_1Zl4-Tp","textFound":"_3vTPnNm"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/SearchResultSummary/SearchResultSummary.less
 ** module id = 790
 ** module chunks = 0
 **/